import React from "react";
import { Box, BoxProps, Text } from "@chakra-ui/react";
import { Row, Col } from "antd";
import colors from "core/resources/theme/colors";

interface RelatorioSectionTitleProps {
  items: {
    text: string;
    bold?: boolean;
    colSpan: number;
    textAlign?: "left" | "center" | "right";
    color?: string;
  }[];
  containerProps?: BoxProps;
}

function RelatorioSectionTitle({
  items,
  containerProps,
}: RelatorioSectionTitleProps) {
  return (
    <Box
      as={Row}
      gutter={2}
      pb={1}
      borderColor={colors.black}
      borderBottomWidth={1}
      {...containerProps}
    >
      {items.map((item, index) => (
        <Box key={index} as={Col} xs={item.colSpan}>
          <Text
            color={item.color || colors.black}
            fontWeight={item.bold ? "bold" : "regular"}
            textAlign={item.textAlign}
          >
            {item.text}
          </Text>
        </Box>
      ))}
    </Box>
  );
}

export default RelatorioSectionTitle;
